import React, { Component } from 'react';
import './Icons.css';
import { Parallax } from 'react-scroll-parallax';
import fb from './fb.png';
import ig from './ig.png';
import { Animation } from 'mdbreact';

class Icons extends Component {
  render() {
    return (
    	<div className="iconCont">
	    	<div className="icons">
	    	<Animation type="slideInRight" reveal duration="1.5s">
	    		<a href="https://www.facebook.com/majaleszlin/" target="_blank" rel="noopener">
	    			<img src={fb} alt="fb" />
	    		</a>
	    		
	    		<a href="https://www.instagram.com/majalesutb/" target="_blank" rel="noopener">
	    			<img src={ig} alt="ig" />
	    		</a>
	    		</Animation>

	    	</div>
	    </div>
    );
  }
}

export default Icons;